import Route from "@ember/routing/route";
import RSVP from "rsvp";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class ServerDisksRoute extends Route {
  @service ajax;
  @service abilities;

  model() {
    let { server, organization } = this.modelFor("server");

    return RSVP.hash({
      server,
      organization,
      limits: this.ajax.request(`${ENV.apiBaseUri}/serverdisk/limits?serverid=${server.id}`),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.set("disks", model.server.additionaldisks);
  }
}
